import enModalUnblockPayment from '@/components/card-payment-value/components/modal-unblock-payment/locales/en.json'
import esModalUnblockPayment from '@/components/card-payment-value/components/modal-unblock-payment/locales/es.json'
import ptModalUnblockPayment from '@/components/card-payment-value/components/modal-unblock-payment/locales/pt.json'
import enPaymentStatus from '@/components/card-payment-value/components/payment-status/locales/en.json'
import esPaymentStatus from '@/components/card-payment-value/components/payment-status/locales/es.json'
import ptPaymentStatus from '@/components/card-payment-value/components/payment-status/locales/pt.json'
import enCardNextPayments from '@/components/card-payment-value/locales/en.json'
import esCardNextPayments from '@/components/card-payment-value/locales/es.json'
import ptCardNextPayments from '@/components/card-payment-value/locales/pt.json'
import enFirebaseConnect from '@/components/firebase-connect/locales/en.json'
import esFirebaseConnect from '@/components/firebase-connect/locales/es.json'
import ptFirebaseConnect from '@/components/firebase-connect/locales/pt.json'
import enGlobal from '@assets/locales/en.json'
import esGlobal from '@assets/locales/es.json'
import ptGlobal from '@assets/locales/pt.json'
import enBannerIdeas from '@components/banner-ideas/locales/en.json'
import esBannerIdeas from '@components/banner-ideas/locales/es.json'
import ptBannerIdeas from '@components/banner-ideas/locales/pt.json'
import enButtonCopyText from '@components/buttons/button-copy-text/locales/en.json'
import esButtonCopyText from '@components/buttons/button-copy-text/locales/es.json'
import ptButtonCopyText from '@components/buttons/button-copy-text/locales/pt.json'
import enCategoriesFormSocialNetworkComponent from '@components/categories-form-social-network/locales/en.json'
import esCategoriesFormSocialNetworkComponent from '@components/categories-form-social-network/locales/es.json'
import ptCategoriesFormSocialNetworkComponent from '@components/categories-form-social-network/locales/pt.json'
import enIncompletePaymentData from '@components/incomplete-payment-data/locales/en.json'
import esIncompletePaymentData from '@components/incomplete-payment-data/locales/es.json'
import ptIncompletePaymentData from '@components/incomplete-payment-data/locales/pt.json'
import enInputBirthday from '@components/inputs/input-birthday/locales/en.json'
import esInputBirthday from '@components/inputs/input-birthday/locales/es.json'
import ptInputBirthday from '@components/inputs/input-birthday/locales/pt.json'
import enInputCountries from '@components/inputs/input-countries/locales/en.json'
import esInputCountries from '@components/inputs/input-countries/locales/es.json'
import ptInputCountries from '@components/inputs/input-countries/locales/pt.json'
import enInputDigits from '@components/inputs/input-digits/locales/en.json'
import esInputDigits from '@components/inputs/input-digits/locales/es.json'
import ptInputDigits from '@components/inputs/input-digits/locales/pt.json'
import enInputCnpj from '@components/inputs/input-document-cnpj/locales/en.json'
import esInputCnpj from '@components/inputs/input-document-cnpj/locales/es.json'
import ptInputCnpj from '@components/inputs/input-document-cnpj/locales/pt.json'
import enInputCpf from '@components/inputs/input-document-cpf/locales/en.json'
import esInputCpf from '@components/inputs/input-document-cpf/locales/es.json'
import ptInputCpf from '@components/inputs/input-document-cpf/locales/pt.json'
import enInputInternational from '@components/inputs/input-document-international/locales/en.json'
import esInputInternational from '@components/inputs/input-document-international/locales/es.json'
import ptInputInternational from '@components/inputs/input-document-international/locales/pt.json'
import enInputRut from '@components/inputs/input-document-rut/locales/en.json'
import esInputRut from '@components/inputs/input-document-rut/locales/es.json'
import ptInputRut from '@components/inputs/input-document-rut/locales/pt.json'
import enInputName from '@components/inputs/input-name/locales/en.json'
import esInputName from '@components/inputs/input-name/locales/es.json'
import ptInputName from '@components/inputs/input-name/locales/pt.json'
import enInputRaces from '@components/inputs/input-races/locales/en.json'
import esInputRaces from '@components/inputs/input-races/locales/es.json'
import ptInputRaces from '@components/inputs/input-races/locales/pt.json'
import enInputZipcode from '@components/inputs/input-zipcode/locales/en.json'
import esInputZipcode from '@components/inputs/input-zipcode/locales/es.json'
import ptInputZipcode from '@components/inputs/input-zipcode/locales/pt.json'
import enInput from '@components/inputs/input/locales/en.json'
import esInput from '@components/inputs/input/locales/es.json'
import ptInput from '@components/inputs/input/locales/pt.json'
import enModalAcceptanceContract from '@components/modals/modal-acceptance-contract/locales/en.json'
import esModalAcceptanceContract from '@components/modals/modal-acceptance-contract/locales/es.json'
import ptModalAcceptanceContract from '@components/modals/modal-acceptance-contract/locales/pt.json'
import enModalContract from '@components/modals/modal-contract/locales/en.json'
import esModalContract from '@components/modals/modal-contract/locales/es.json'
import ptModalContract from '@components/modals/modal-contract/locales/pt.json'
import enModalUnsaveData from '@components/modals/modal-unsave-data/locales/en.json'
import esModalUnsaveData from '@components/modals/modal-unsave-data/locales/es.json'
import ptModalUnsaveData from '@components/modals/modal-unsave-data/locales/pt.json'
import enModalVinculateSocialNetwork from '@components/modals/modal-vinculate-social-network/locales/en.json'
import esModalVinculateSocialNetwork from '@components/modals/modal-vinculate-social-network/locales/es.json'
import ptModalVinculateSocialNetwork from '@components/modals/modal-vinculate-social-network/locales/pt.json'
import enNextPayments from '@components/next-payments/locales/en.json'
import esNextPayments from '@components/next-payments/locales/es.json'
import ptNextPayments from '@components/next-payments/locales/pt.json'
import enSocialItem from '@components/social-item/locales/en.json'
import esSocialItem from '@components/social-item/locales/es.json'
import ptSocialItem from '@components/social-item/locales/pt.json'
import enSubCategoriesFormSocialNetworkComponent from '@components/sub-categories-form-social-network/locales/en.json'
import esSubCategoriesFormSocialNetworkComponent from '@components/sub-categories-form-social-network/locales/es.json'
import ptSubCategoriesFormSocialNetworkComponent from '@components/sub-categories-form-social-network/locales/pt.json'
import enToggleTheme from '@components/toggle-theme/locales/en.json'
import esToggleTheme from '@components/toggle-theme/locales/es.json'
import ptToggleTheme from '@components/toggle-theme/locales/pt.json'
import enUseLinkSocialNetworkHook from '@hooks/use-link-social-network/locales/en.json'
import esUseLinkSocialNetworkHook from '@hooks/use-link-social-network/locales/es.json'
import ptUseLinkSocialNetworkHook from '@hooks/use-link-social-network/locales/pt.json'
import enUseSocialNetworkInformationActionsHook from '@hooks/use-social-network-information-actions/locales/en.json'
import esUseSocialNetworkInformationActionsHook from '@hooks/use-social-network-information-actions/locales/es.json'
import ptUseSocialNetworkInformationActionsHook from '@hooks/use-social-network-information-actions/locales/pt.json'
import enNavigationLayout from '@layouts/navigation/locales/en.json'
import esNavigationLayout from '@layouts/navigation/locales/es.json'
import ptNavigationLayout from '@layouts/navigation/locales/pt.json'

import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

export const defaultNS = 'globals'
export const resources = {
  en: {
    globals: enGlobal,
    input: enInput,
    toggleTheme: enToggleTheme,
    navigationLayout: enNavigationLayout,
    inputDigits: enInputDigits,
    inputDocumentCpf: enInputCpf,
    inputDocumentRut: enInputRut,
    inputDocumentInternational: enInputInternational,
    inputBirthday: enInputBirthday,
    inputName: enInputName,
    inputCountries: enInputCountries,
    useLinkSocialNetworkHook: enUseLinkSocialNetworkHook,
    useSocialNetworkInformationActionsHook: enUseSocialNetworkInformationActionsHook,
    inputRaces: enInputRaces,
    inputZipcode: enInputZipcode,
    modalContract: enModalContract,
    buttonCopyText: enButtonCopyText,
    categoriesFormSocialNetworkComponent: enCategoriesFormSocialNetworkComponent,
    subCategoriesFormSocialNetworkComponent: enSubCategoriesFormSocialNetworkComponent,
    modalVinculateSocialNetwork: enModalVinculateSocialNetwork,
    modalUnsaveData: enModalUnsaveData,
    incompletePaymentData: enIncompletePaymentData,
    modalAcceptanceContract: enModalAcceptanceContract,
    bannerIdeas: enBannerIdeas,
    cardNextPayments: enCardNextPayments,
    modalUnblockPayment: enModalUnblockPayment,
    paymentStatus: enPaymentStatus,
    nextPayments: enNextPayments,
    inputDocumentCnpj: enInputCnpj,
    socialItem: enSocialItem,
    firebaseConnect: enFirebaseConnect,
  },
  pt: {
    globals: ptGlobal,
    input: ptInput,
    toggleTheme: ptToggleTheme,
    navigationLayout: ptNavigationLayout,
    inputDigits: ptInputDigits,
    inputDocumentCpf: ptInputCpf,
    inputDocumentRut: ptInputRut,
    inputDocumentInternational: ptInputInternational,
    inputBirthday: ptInputBirthday,
    inputName: ptInputName,
    inputCountries: ptInputCountries,
    useLinkSocialNetworkHook: ptUseLinkSocialNetworkHook,
    useSocialNetworkInformationActionsHook: ptUseSocialNetworkInformationActionsHook,
    inputRaces: ptInputRaces,
    inputZipcode: ptInputZipcode,
    modalContract: ptModalContract,
    buttonCopyText: ptButtonCopyText,
    categoriesFormSocialNetworkComponent: ptCategoriesFormSocialNetworkComponent,
    subCategoriesFormSocialNetworkComponent: ptSubCategoriesFormSocialNetworkComponent,
    modalVinculateSocialNetwork: ptModalVinculateSocialNetwork,
    modalUnsaveData: ptModalUnsaveData,
    incompletePaymentData: ptIncompletePaymentData,
    modalAcceptanceContract: ptModalAcceptanceContract,
    bannerIdeas: ptBannerIdeas,
    cardNextPayments: ptCardNextPayments,
    modalUnblockPayment: ptModalUnblockPayment,
    paymentStatus: ptPaymentStatus,
    nextPayments: ptNextPayments,
    inputDocumentCnpj: ptInputCnpj,
    socialItem: ptSocialItem,
    firebaseConnect: ptFirebaseConnect,
  },
  es: {
    globals: esGlobal,
    input: esInput,
    toggleTheme: esToggleTheme,
    navigationLayout: esNavigationLayout,
    inputDigits: esInputDigits,
    inputDocumentCpf: esInputCpf,
    inputDocumentRut: esInputRut,
    inputDocumentInternational: esInputInternational,
    inputBirthday: esInputBirthday,
    inputName: esInputName,
    inputCountries: esInputCountries,
    useLinkSocialNetworkHook: esUseLinkSocialNetworkHook,
    useSocialNetworkInformationActionsHook: esUseSocialNetworkInformationActionsHook,
    inputRaces: esInputRaces,
    inputZipcode: esInputZipcode,
    modalContract: esModalContract,
    buttonCopyText: esButtonCopyText,
    categoriesFormSocialNetworkComponent: esCategoriesFormSocialNetworkComponent,
    subCategoriesFormSocialNetworkComponent: esSubCategoriesFormSocialNetworkComponent,
    modalVinculateSocialNetwork: esModalVinculateSocialNetwork,
    modalUnsaveData: esModalUnsaveData,
    incompletePaymentData: esIncompletePaymentData,
    modalAcceptanceContract: esModalAcceptanceContract,
    bannerIdeas: esBannerIdeas,
    cardNextPayments: esCardNextPayments,
    modalUnblockPayment: esModalUnblockPayment,
    paymentStatus: esPaymentStatus,
    nextPayments: esNextPayments,
    inputDocumentCnpj: esInputCnpj,
    socialItem: esSocialItem,
    firebaseConnect: esFirebaseConnect,
  },
} as const

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: [
      'globals',
      'input',
      'toggleTheme',
      'defaultLayout',
      'navigationLayout',
      'inputDigits',
      'inputDocumentCpf',
      'inputDocumentRut',
      'inputDocumentInternational',
      'inputBirthday',
      'inputName',
      'inputCountries',
      'inputRaces',
      'inputZipcode',
      'inputDocumentCnpj',
      'modalContract',
      'buttonCopyText',
      'categoriesFormSocialNetworkComponent',
      'subCategoriesFormSocialNetworkComponent',
      'useLinkSocialNetworkHook',
      'useSocialNetworkInformationActionsHook',
      'modalVinculateSocialNetwork',
      'modalUnsaveData',
      'incompletePaymentData',
      'modalAcceptanceContract',
      'bannerIdeas',
      'cardNextPayments',
      'modalUnblockPayment',
      'paymentStatus',
      'nextPayments',
      'socialItem',
      'firebaseConnect',
    ],
    load: 'all',
    supportedLngs: ['en', 'es', 'pt'],
    fallbackLng: 'en',
    lng: navigator.language?.split('-')[0] || 'en',
    debug: false,
    cache: {
      enabled: false,
    },
    interpolation: {
      escapeValue: false,
    },
    resources,
  })

export default i18n
